<template>
    <b-modal id="modal-rincian" title="Hasil Perhitungan" size="lg" no-close-on-backdrop no-close-on-esc
        :hide-header-close="isSubmitting" :ok-title="isSubmitting ? 'Menghitung....' : 'Lanjutkan'"
        :ok-disabled="nilaiPinjaman == '' || isSubmitting" @ok.prevent="executeNext" @shown="focusInputPinjaman"
        cancel-title="Tutup">
        <div class="detail-data-wrapper mb-4">
            <h6 class="form-title mb-2">RINCIAN GADAI</h6>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Barang</b-col>
                <b-col>
                    <div v-if="rincian.namaBarang != null">
                        {{ rincian.namaBarang }}
                        <br>
                        <br>
                        {{ rincian.gosokCapKwitansi }}
                        <br>
                        <br>
                        {{ rincian.batuBarang }}
                    </div>
                    <div v-else>
                        {{ namaLengkapBarang }}
                    </div>
                </b-col>
            </b-row>
            <b-row v-if="!$helper.isNullOrEmpty(rincian.input) && !$helper.isNullOrEmpty(rincian.input.capEmas)" class="mb-2">
                <b-col cols="5" class="detail-data-label">Merk Cap Emas</b-col>
                <b-col class="detail-data-label">{{ rincian.input.capEmas.name }}</b-col>
            </b-row>
            <b-row v-if="!$helper.isNullOrEmpty(rincian.input) && !$helper.isNullOrEmpty(rincian.input.kemasanEmas)" class="mb-2">
                <b-col cols="5" class="detail-data-label">Jenis Kemasan Emas</b-col>
                <b-col class="detail-data-label">{{ rincian.input.kemasanEmas.name }}</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Spek Barang</b-col>
                <b-col>
                    <strong v-if="rincian.spekBarang == 2">RESMI</strong>
                    <strong v-else-if="rincian.spekBarang == 5">LN</strong>
                    <strong v-else>-</strong>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col v-if="rincian.detailBatu != null && rincian.detailBatu.length != 0" cols="5"
                    class="detail-data-label">Potongan Berat</b-col>
                <b-col>
                    <div v-for="(item, index) of rincian.detailBatu" :key="index">
                        - {{ item }}
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Harga Barang</b-col>
                <b-col>
                    Rp. {{ $helper.addThousandSeparator(rincian.hargaBarang) }}
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Kondisi - Grade {{ rincian.perhitunganKondisi.name }}</b-col>
                <b-col v-if="rincian.perhitunganKondisi.nominal < 0" class="text-danger">
                    Rp. {{ $helper.addThousandSeparator(rincian.perhitunganKondisi.nominal) }}
                </b-col>
                <b-col v-else>
                    Rp. {{ $helper.addThousandSeparator(rincian.perhitunganKondisi.nominal) }}
                </b-col>
            </b-row>
            <b-row class="mb-2" v-if="rincian.perhitunganBonusGadaiPertama != null">
                <b-col cols="5" class="detail-data-label">{{ rincian.perhitunganBonusGadaiPertama.name }}</b-col>
                <b-col>
                    Rp. {{ $helper.addThousandSeparator(rincian.perhitunganBonusGadaiPertama.nominal) }}
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Adjustment Status Anggota</b-col>
                <b-col v-if="rincian.perhitunganStatusAnggota.nominal < 0" class="text-danger">
                    Rp. {{ $helper.addThousandSeparator(rincian.perhitunganStatusAnggota.nominal) }}
                </b-col>
                <b-col v-else>
                    Rp. {{ $helper.addThousandSeparator(rincian.perhitunganStatusAnggota.nominal) }}
                </b-col>
            </b-row>
            <b-row class="mb-2" v-if="rincian.perhitunganAdjustmentSkemaDidepan != null">
                <b-col cols="5" class="detail-data-label">Adjustment Jasa Didepan</b-col>
                <b-col v-if="rincian.perhitunganAdjustmentSkemaDidepan < 0" class="text-danger">
                    Rp. {{ $helper.addThousandSeparator(rincian.perhitunganAdjustmentSkemaDidepan) }}
                </b-col>
                <b-col v-else>
                    Rp. {{ $helper.addThousandSeparator(rincian.perhitunganAdjustmentSkemaDidepan) }}
                </b-col>
            </b-row>
            <b-row class="mb-2" v-for="item in rincian.perhitunganPromo" v-bind:key="item.name">
                <b-col cols="5" class="detail-data-label">Promo: {{ item.name }}</b-col>
                <b-col v-if="item.nominal < 0" class="text-danger">
                    Rp. {{ $helper.addThousandSeparator(item.nominal) }}
                </b-col>
                <b-col v-else>
                    Rp. {{ $helper.addThousandSeparator(item.nominal) }}
                </b-col>
            </b-row>
        </div>
        <div class="detail-data-wrapper mb-4">
            <h6 class="form-title mb-2">RINCIAN SPESIFIKASI</h6>
            <div v-if="rincian.perhitunganSpek.length != 0">
                <b-row v-for="item in rincian.perhitunganSpek" v-bind:key="item.name" class="mb-2">
                    <b-col cols="5" class="detail-data-label">{{ item.name }}</b-col>
                    <b-col v-if="item.nominal < 0" class="text-danger">
                        Rp. {{ $helper.addThousandSeparator(item.nominal) }}
                    </b-col>
                    <b-col v-else>
                        Rp. {{ $helper.addThousandSeparator(item.nominal) }}
                    </b-col>
                </b-row>
            </div>
            <p v-else>Tidak ada</p>
        </div>
        <div class="detail-data-wrapper mb-4">
            <h6 class="form-title mb-2">PERHITUNGAN PINJAMAN</h6>
            <b-row class="mb-2" v-if="rincian.hargaMaksimalKondisi != null">
                <b-col cols="5" class="detail-data-label">Harga Maksimal Kondisi</b-col>
                <b-col>
                    Rp. {{ $helper.addThousandSeparator(rincian.hargaMaksimalKondisi) }}
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Pinjaman Maksimal</b-col>
                <b-col>
                    Rp. {{ $helper.addThousandSeparator(rincian.maksimumPinjaman) }}
                    <span class="smallText text-muted">
                        (Setelah Pembulatan)
                    </span>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Pinjaman Minimal</b-col>
                <b-col>
                    Rp. {{ $helper.addThousandSeparator(rincian.minimumPinjaman) }}
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Nilai Pinjaman</b-col>
                <b-col>
                    <b-input-group prepend="Rp.">
                        <b-form-input v-model="nilaiPinjaman" @focus="$event.target.select()" ref="inputNilaiPinjaman"
                            v-on:keyup.enter="executeNext" name="nilaiPinjaman" required></b-form-input>
                    </b-input-group>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Voucher Diskon</b-col>
                <b-col>
                    <b-input-group>
                        <b-input-group-prepend is-text>
                            <b-form-checkbox v-model="useVoucher" @change="onUseVoucherChange" />
                        </b-input-group-prepend>
                        <b-form-input v-model="voucherCode" :disabled="!useVoucher"></b-form-input>
                    </b-input-group>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Metode Pencairan</b-col>
                <b-col>
                    <b-form-select v-model="disburseType">
                        <b-form-select-option :value="TUNAI">Tunai</b-form-select-option>
                        <b-form-select-option :value="NON_TUNAI">Non Tunai (Transfer)</b-form-select-option>
                    </b-form-select>
                </b-col>
            </b-row>
            <b-row class="mb-2" v-if="installmentActive">
                <b-col cols="5" class="detail-data-label">Metode Gadai</b-col>
                <b-col>
                    <b-form-select v-model="metodeGadai" name="metodeGadai" :options="optionsMetodeGadai">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>Silahkan pilih metode gadai</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
            </b-row>
            <b-row class="mb-2" v-if="installmentActive && metodeGadai == 'angsuran'">
                <b-col cols="5" class="detail-data-label">Tenor</b-col>
                <b-col>
                    <b-form-select v-model="tenor" name="tenor" :options="optionsTenor">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>Silahkan pilih tenor</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
            </b-row>
            <b-row class="mb-2" v-if="installmentActive && metodeGadai == 'angsuran' && tenor != null && jadwalAngsuran.length > 0">
                <b-col cols="5" class="detail-data-label">Angsuran per Bulan</b-col>
                <b-col>
                    Rp. {{ $helper.addThousandSeparator(angsuranPerBulan) }}
                    <a class="ml-2" style="cursor:pointer; font-weight:bold; color:#1e73be" @click="showJadwalAngsuran = !showJadwalAngsuran">
                        {{ showJadwalAngsuran ? 'Sembunyikan Rincian' : 'Lihat Rincian' }}
                    </a>
                    <b-collapse v-model="showJadwalAngsuran" class="mt-2">
                        <div class="rincian-angsuran">
                            <div v-for="row in jadwalAngsuran" :key="row.bulan" class="d-flex justify-content-between py-1 border-bottom">
                                <span class="text-muted">Angsuran {{ row.bulan }}</span>
                                <strong>Rp. {{ $helper.addThousandSeparator(row.cicilan) }}</strong>
                            </div>
                        </div>
                    </b-collapse>
                </b-col>
            </b-row>
            <b-row class="mb-2" v-if="installmentActive && metodeGadai == 'angsuran' && tenor != null && jadwalAngsuran.length > 0">
                <b-col cols="5" class="detail-data-label">Total Angsuran</b-col>
                <b-col><strong>Rp. {{ $helper.addThousandSeparator(totalAngsuran) }}</strong></b-col>
            </b-row>
        </div>
        <b-alert variant="warning" class="mt-0" :show="rincian.isImeiBlacklisted">
            <strong>
                Perhatian!
            </strong>
            <br />
            IMEI ini di blacklist, harap cek terlebih dahulu.
        </b-alert>
        <b-alert :show="rincian.showAlertNoFakturGanda" variant="warning" class="my-4">
            <div>
                <strong>
                    Perhatian!
                </strong>
                <span v-if="rincian.alertGadai == 'kend'">
                    No. Polisi <strong>{{ rincian.alertNoPol }}</strong> atau No. Mesin
                    <strong>{{ rincian.alertNoMesin }}</strong> sudah digunakan pada No. Faktur
                    <strong>{{ rincian.alertNoFakturGanda }}</strong>!
                    Periksa kembali apabila sudah pernah digadaikan, lalu hubungi HO untuk pengecekan lebih lanjut!
                </span>
                <span v-else>
                    IMEI / SN <strong>{{ rincian.alertNoImei }}</strong> sudah digunakan pada No. Faktur
                    <strong>{{ rincian.alertNoFakturGanda }}</strong>!
                    Periksa kembali apabila barang ini sudah digadaikan!
                </span>
            </div>
        </b-alert>
        <b-alert :show="rincian.warnCpuZ == true" variant="primary" class="my-4">
            <div>
                <strong>
                    Perhatian! Cek Keaslian Android pada Device Info!
                </strong><br />

                Mohon pastikan sudah download aplikasi <strong> Device Info / Informasi Perangkat: CPU Sistem
                </strong>(Developer / Pengembang
                Aplikasi dengan nama <strong> Yasiru Nayanajith</strong>) dan mengikuti langkah-langkah sesuai SE terkait
                <strong> Perbedaan Handphone
                    / Tab Asli dan Palsu Khusus Android!</strong>
            </div>
        </b-alert>
      
    </b-modal>
</template>

<script>
import CONSTANTS from '@/constants'

const { JENIS } = CONSTANTS.GADAI

export default {
    name: 'modal-rincian',
    props: {
        namaLengkapBarang: { type: String, required: true },
        isSubmitting: { type: Boolean, required: true },
        rincian: { type: Object, required: true },
        defaultMetodeGadai: { type: String, default: null },
        defaultTenor: { type: Number, default: null },
        defaultNilaiPinjaman: { type: [Number, String], default: 0 },
        jenisPinjaman: { type: Number, required: true },
        bpkbOnly: { type: [Boolean, String], default: true },
    },
    data() {
        return {
            nilaiPinjaman: "",
            voucherCode: "",
            useVoucher: false,
            disburseType: 0,
            metodeGadai: this.defaultMetodeGadai,
            tenor: this.defaultTenor,
            optionsMetodeGadai: [
                { value: 'non_angsuran', text: 'Non Angsuran' },
                { value: 'angsuran', text: 'Angsuran' },
            ],
            jadwalAngsuran: [],
            totalAngsuran: 0,
            showJadwalAngsuran: false,
        }
    },
    computed: {
        TUNAI() {
            return CONSTANTS.GADAI.METODE_PENCAIRAN.TUNAI
        },
        NON_TUNAI() {
            return CONSTANTS.GADAI.METODE_PENCAIRAN.NON_TUNAI
        },
        angsuranPerBulan() {
            return this.jadwalAngsuran.length > 0 ? this.jadwalAngsuran[0].cicilan : 0
        },
        installmentActive() {
            return !!(this.$store.state.cabang && this.$store.state.cabang.installmentActive)
        },
        optionsTenor() {
            const tenor = { [JENIS.ELEKTRONIK]: [3, 6], [JENIS.KENDARAAN]: [3, 6, 12, 18, 24] }[this.jenisPinjaman] || [3, 6, 12]
            return tenor.map(value => ({ value, text: `${value} Bulan` }))
        },
    },
    methods: {

        getSimulasiAngsuran() {
            const endpoint = {
                [JENIS.ELEKTRONIK]: "gadai-crud/simulasi-angsuran/elektronik",
                [JENIS.KENDARAAN]: "gadai-crud/simulasi-angsuran/kendaraan",
                [JENIS.EMAS]: "gadai-emas/simulasi-angsuran",
            }[this.jenisPinjaman]
            if (!endpoint) return
            const params = {
                tenor: this.tenor,
                pinjamanPokokAwal: this.$helper.removeThousandSeparator(this.nilaiPinjaman),
            }
            if (this.jenisPinjaman == JENIS.KENDARAAN) params.bpkbOnly = String(this.bpkbOnly) != "false"
            this.$axios.get(endpoint, { params }).then(response => {
                const simulasi = response.data && response.data.simulasiAngsuran
                this.jadwalAngsuran = Array.isArray(simulasi) ? simulasi : []
                this.totalAngsuran = response.data && response.data.totalAngsuran || 0
            })
            .catch(error => {
                this.jadwalAngsuran = []
                this.showJadwalAngsuran = false
                this.$helper.parseError(this, error)
            })
        },

        executeNext() {
            if (this.useVoucher && this.$helper.isNullOrEmpty(this.voucherCode)) {
                this.$helper.toastErr(this, "Kode voucher harus diinput terlebih dahulu.")
                return;    
            }
            
            let pinjaman = this.$helper.removeThousandSeparator(this.nilaiPinjaman)

            if (pinjaman > this.rincian.maksimumPinjaman) {
                this.$helper.toastErr(this, "Nilai pinjaman melebihi maksimum!")
                return
            }

            if (pinjaman < this.rincian.minimumPinjaman) {
                this.$helper.toastErr(this, "Nilai pinjaman tidak mencapai minimum peminjaman!")
                return
            }

            if (!this.installmentActive) this.metodeGadai = 'non_angsuran'

            if (this.$helper.isNullOrEmpty(this.metodeGadai)) {
                this.$helper.toastErr(this, "Metode gadai wajib dipilih.")
                return
            }

            if (this.metodeGadai == 'angsuran' && this.$helper.isNullOrEmpty(this.tenor)) {
                this.$helper.toastErr(this, "Tenor wajib dipilih.")
                return
            }

            let data = {
                nilaiPinjaman: pinjaman,
                useVoucher: this.useVoucher,
                voucherCode: this.voucherCode,
                disburseType: this.disburseType,
                metodeGadai: this.metodeGadai,
                tenor: this.metodeGadai == 'angsuran' ? this.tenor : null,
                angsuranPerBulan: this.angsuranPerBulan,
                jadwalAngsuran: this.jadwalAngsuran,
            }

            this.$emit("next", data)

        },
        focusInputPinjaman() {
            this.$refs.inputNilaiPinjaman.focus()
        },
          onUseVoucherChange(val) {
            if (!val) {
            this.voucherCode = '';
            }
          },

    },
    watch: {

        metodeGadai: function (newVal) {
            if (newVal != 'angsuran') {
                this.tenor = null;
                this.jadwalAngsuran = [];
                this.showJadwalAngsuran = false;
            }
        },

        tenor: function (newVal) {
            this.jadwalAngsuran = [];
            this.showJadwalAngsuran = false;
            if (this.$helper.isNullOrEmpty(newVal)) {
                return;
            }
            this.getSimulasiAngsuran();
        },

        nilaiPinjaman: function (newValue) {

            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");

            this.$nextTick(() => this.nilaiPinjaman = result)

            if (this.metodeGadai == 'angsuran' && !this.$helper.isNullOrEmpty(this.tenor)) {
                this.showJadwalAngsuran = false
                clearTimeout(this._angsuranTimer)
                this._angsuranTimer = setTimeout(() => {
                    this.getSimulasiAngsuran()
                }, 500)
            }

        },

        "rincian.maksimumPinjaman": function (newValue) {
            const fromSimulasi = this.$helper.removeThousandSeparator(this.defaultNilaiPinjaman)
            this.nilaiPinjaman = this.$helper.addThousandSeparator(fromSimulasi > 0 ? fromSimulasi : newValue)
            this.voucherCode = ""
            this.useVoucher = false
            this.metodeGadai = this.defaultMetodeGadai
            this.tenor = this.defaultTenor
            this.jadwalAngsuran = []
            this.showJadwalAngsuran = false
        },

        "rincian": function (newVal, oldVal) {
            if (this.$helper.isNullOrEmpty(this.rincian.noImei)) {
                this.rincian.noImei = oldVal.noImei
                this.rincian.spekBarang = oldVal.spekBarang
            }
        }

    }
}
</script>
